<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" @close="close">
    <el-form>
      <el-collapse v-model="activeNames">
        <el-collapse-item
          :title="`案件: ${caseItem.defendant} - ${(caseItem.agreement && caseItem.agreement.HouseName) || ''}`"
          :name="index"
          v-for="(caseItem, index) in fill_list"
          :key="caseItem.id || index">
          <el-form :model="caseItem" :ref="`subForm_${index}`" :rules="subFormRules">
            <el-form-item label="费用类型" label-width="120px" prop="fill_type">
              <el-select v-model="caseItem.fill_type" clearable placeholder="请选择费用类型">
                <el-option v-for="(item,fIndex) in fill_type" :key="item.id || fIndex" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用金额" label-width="120px" prop="fill_money">
              <el-input v-model="caseItem.fill_money" type="number" placeholder="请输入费用金额"></el-input>
            </el-form-item>
            <el-form-item label="费用期限" label-width="120px">
              <el-date-picker v-model="caseItem.fill_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="票据号" label-width="120px">
              <el-input v-model="caseItem.invoice_no" placeholder="请输入票据号"></el-input>
            </el-form-item>
            <el-form-item label="上传文件" label-width="120px" prop="file">
              <div style="width:100%">
                <el-upload
                  :http-request="(params) => handleUploadFile(params, caseItem, 'fill_file')"
                  action=""
                  multiple
                  :data="{key : 'fill_file' , data: caseItem}"
                  :file-list="caseItem.file">
                  <el-button size="small" type="primary">+</el-button>
                </el-upload>
                <span style="color: #909399; font-size: 12px;">(包括但不限于缴费通知、保单等文件/项目经理或分公司法务已做垫付，还需上传垫付成功凭证)</span>
              </div>
            </el-form-item>
            <el-form-item label="备注" label-width="120px" prop="remark">
              <el-input type="textarea" v-model="caseItem.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <el-form-item label-width="120px">
        <el-button type="primary" @click="sendFillMoney" :loading="loading">确定</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import law from "./case.js";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "CaseFill",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data_type: {
      type: String,
      default: ''
    },
    project_type: {
      type: Number,
      default: ''
    },
    case_list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '费用缴纳',
      activeNames: [],
      fill_type: [],
      loading: false,
      subFormRules: {
        fill_type: [
          { required: true, message: '请选择费用类型', trigger: 'change' }
        ],
        fill_money: [
          { required: true, message: '请输入费用金额', trigger: 'blur' },
          { type: 'number', message: '金额必须为数字', trigger: 'blur' }
        ]
      },
      fill_list : [],
    };
  },
  watch: {
    visible: {
      handler: function(val) {
        this.dialogVisible = val;
        if(val) {
          this.resetData();
        }
      },
      deep: true
    },
  },
  mounted() {
    let caseFill = law.caseFillType();
    this.fill_type = Object.keys(caseFill).map(key => {
      return {
        label: caseFill[key],
        value: parseInt(key)
      };
    });
  },
  methods: {
    resetData() {
      this.fill_list = [];
      this.case_list.forEach(item => {
        let cItem = {
          ...item,
          fill_type: item.fill_type || '',
          fill_money: item.fill_money || 0,
          fill_date: item.fill_date || '',
          invoice_no: item.invoice_no || '',
          file: item.file || [],
          remark: item.remark || '',
          file_list: item.file_list || []
        };
        this.fill_list.push(cItem);
      });
    },
    handleUploadFile(params, caseItem, file_key) {
      let file_name = params.file.name;

      law.uploadFile(params.file , (res) =>{
        if(res && res.hasOwnProperty('path')){
          if(!caseItem.hasOwnProperty('file_list')){
            caseItem.file_list = [];
          }
          caseItem.file_list.push({
            file_name : file_name ,
            file_key : file_key ,
            file_url : res.path
          });
        }
      })
    },
    sendFillMoney() {
      let max_money = 0;
      let post_params = {
        flow_list : [],
        flow_type : 'fill'
      };

      this.fill_list.forEach((item , index) => {
        if(!item.fill_type){
          this.$message.error('请选择费用类型');
          return;
        }
        if(!item.fill_money || parseFloat(item.fill_money) <= 0){
          this.$message.error('请输入有效金额');
          return;
        }

        if(parseFloat(item.fill_money) > max_money){
          max_money = parseFloat(item.fill_money);
        }

        let flow_data = {
          fill_type: item.fill_type,
          fill_money: item.fill_money,
          file_date: item.fill_date,
          invoice_no: item.invoice_no,
          remark : item.remark ,
        };

        post_params.flow_list.push({
          case_id : item.id,
          flow_data : flow_data ,
          file_list : item.file_list || []
        });
      });

      this.loading = true;
      ButlerHttp.post('LawCase/saveFlow' , post_params , (res) =>{
        if(res.code){
          let batch_no = res.data.batch_no;
          let project_type_label = this.project_type == 1 ? '在管' : '撤场'
          let url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=351&master_id=288&timeValue=" + law.getTimestamp() + "&batch_no=" + batch_no + "&amount=" + max_money + '&type=' + project_type_label;
          window.open(url);
          this.close();
          this.$message.success('操作成功');
        }else{
          this.$message.error(res.msg);
        }
        this.loading = false;
      });
    },
    close() {
      this.dialogVisible = false;
      this.$emit('close', false);
    }
  }
};
</script>

<style scoped>
.el-collapse-item__header {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_fill.vue